import {Link} from "react-router-dom";

export default function MainBlockCareer(props) {
    return (
        <section className="main_block main_block_career">
            <div className="container">
                <div className="bread_crumbs">
                    <div>
                        <Link to="/">Главная</Link>
                    </div>
                    <div>></div>
                    <div>Карьера</div>
                </div>
                <h1>
                    <span className="title main_title">Карьера</span>
                </h1>
            </div>
        </section>
    )
}
